document.addEventListener('DOMContentLoaded', function() {
    var tableGhsH = document.getElementById('table-ghs-h');
    var tableGhsP = document.getElementById('table-ghs-p');
    var ghsElement = document.getElementById('ghs');

    if (tableGhsH && tableGhsP && ghsElement) {

        var hazardCodes = ghsElement.dataset.ghs ? ghsElement.dataset.ghs.split(',').map(function (hazardCode) {
            return hazardCode.trim().replace(/\s/g, '');
        }) : [];

        //var assetUrl = 'http://127.0.0.1:9292/assets/';
        var assetUrl = 'https://naturkosmetik-werkstatto.shop/cdn/shop/t/4/assets/';

        var rawLanguage = document.documentElement.lang.substring(0, 2);
        var language = (rawLanguage === 'de' || rawLanguage === 'en') ? rawLanguage : 'en';
        var data = {};
        var displayedPictograms = new Set();

        fetch(`${assetUrl}GHS_${language}.json`)
            .then(function (response) {
                return response.json();
            })
            .then(function (jsonData) {
                processHazardCodes(jsonData, hazardCodes);
            })
            .catch(function (err) {
                console.error('Error fetching data:', err);
            });

        var processHazardCodes = function (data, hazardCodes) {

            var tableFragmentH = document.createDocumentFragment();
            var tableFragmentP = document.createDocumentFragment();

            hazardCodes.forEach(function (hazardCode) {

                var hazardData = hazardCode.startsWith('H') ? data.HazardStatements?.[hazardCode] : data.PrecautionaryStatements?.[hazardCode];

                if (hazardCode.startsWith('H') && hazardData?.pictogram) {
                    appendPictograms(hazardData.pictogram, displayedPictograms, assetUrl);
                }

                if (hazardData?.description) {
                    var tr = document.createElement('tr');
                    tr.appendChild(createTableCell(hazardCode));
                    tr.appendChild(createTableCell(hazardData.description));

                    if (hazardCode.startsWith('H')) {
                        tableFragmentH.appendChild(tr);
                    } else if (hazardCode.startsWith('P')) {
                        tableFragmentP.appendChild(tr);
                    }
                }

            });

            tableGhsH.appendChild(tableFragmentH);
            tableGhsP.appendChild(tableFragmentP);
        };

        function appendPictograms(pictograms, displayedPictograms, assetUrl) {
            var ghsPictrograms = document.getElementById('ghs-pictograms');
            pictograms.forEach(function (pictogram) {
                if (!displayedPictograms.has(pictogram)) {
                    var img = document.createElement('img');
                    img.src = `${assetUrl}${pictogram}.svg`;
                    img.classList.add('nkw-hp-pictogram');
                    img.alt = `Pictogram ${pictogram}`;
                    ghsPictrograms.appendChild(img);
                    displayedPictograms.add(pictogram);
                }
            });
        }

        function createTableCell(content) {
            var td = document.createElement('td');
            td.textContent = content;
            return td;
        }

    }

    var drawerRight = document.getElementById('open-drawer-right');
    if (drawerRight) {
        function openDrawerRight(e) {

            e.preventDefault();

            var drawers = document.querySelectorAll('[id^="StoreAvailabilityModal-"]');
            for (var i = 0; i < drawers.length; i++) {
                drawers[i].setAttribute('open', '');
            }

        }

        drawerRight.onclick = openDrawerRight;
    }

    /// SINGLE PRODUCT HEADER MENU – SCROLL TO SECTION
    var menu = document.querySelector('.nkw-product-header-links');
    if (menu) {
        var scolllinks = menu.querySelectorAll('a');

        function updateActiveLink() {
            var scrollPosition = window.pageYOffset + 300;
            var currentActiveLink = null;

            scolllinks.forEach(function(link) {
                var href = link.getAttribute('href');
                if (href.startsWith('#')) {
                    var target = document.querySelector(href);
                    if (target) {
                        var targetTop = target.offsetTop;
                        var targetBottom = targetTop + target.offsetHeight;

                        if (scrollPosition >= targetTop && scrollPosition < targetBottom) {
                            currentActiveLink = link;
                        }
                    }
                }
            });

            scolllinks.forEach(function(link) {
                link.classList.remove('active');
            });

            if (currentActiveLink) {
                currentActiveLink.classList.add('active');
            }
        }

        window.addEventListener('scroll', updateActiveLink);

        updateActiveLink();

        scolllinks.forEach(function (link) {
            link.addEventListener('click', function (event) {

                links.forEach(function (otherLink) {
                    otherLink.classList.remove('active');
                });

                this.classList.add('active');

                var href = this.getAttribute('href');
                var offset = 205;

                if (href.includes('#description')) {
                    offset = 250;
                }

                if (href.includes('#shopify-block-reviews_io_reviewsio_polaris_3AJccn')) {
                    offset = 350;
                }

                if (href.startsWith('#')) {
                    var scrollanchor = document.querySelector(href);
                    setTimeout(function () {
                        window.scrollTo({
                            top: scrollanchor.getBoundingClientRect().top + window.pageYOffset - offset,
                            behavior: 'smooth'
                        });
                    }, 100);
                    event.preventDefault();
                } else {
                    window.location.href = href;
                }
            });
        });
    }


    /// TOGGLE CONTENT
    var toggleButton = document.querySelectorAll('.container-toggle-button');
    if (toggleButton) {
        toggleButton.forEach(function (btn) {
            btn.addEventListener('click', function () {
                var container = this.parentElement.previousElementSibling;
                if (container && container.classList.contains('container-toggle')) {
                    if (this.textContent === 'Mehr dazu') {
                        this.textContent = 'Schließen';
                    } else {
                        this.textContent = 'Mehr dazu';
                    }
                    this.classList.toggle('active');
                    container.classList.toggle('expanded');
                }
            });
        });
    }

    var blogLinks = document.querySelectorAll('.blog-category-menu a');

    if (blogLinks) {
        Array.prototype.forEach.call(blogLinks, function (link) {
            link.addEventListener('click', function (event) {
                event.preventDefault();
                var blogHandle = this.getAttribute('data-blog-handle');
                fetchBlogArticles(blogHandle);
            });
        });

        function fetchBlogArticles(blogHandle) {
            var url = '/blogs/' + blogHandle + '?view=blog-articles&layout=ajax';

            fetch(url)
                .then(function (response) {
                    return response.text();
                })
                .then(function (data) {

                    var parser = new DOMParser();

                    var doc = parser.parseFromString(data, 'text/html');

                    var articleList = doc.getElementById('article-list');

                    if (articleList) {
                        document.getElementById('blog-articles').innerHTML = articleList.innerHTML;
                        var articleItems = document.getElementById('blog-articles').querySelectorAll('.article-item');

                        articleItems.forEach(function (item) {
                            item.removeAttribute('reveal');
                        });
                    }
                })
                .catch(function (error) {
                    console.error('Error fetching articles:', error);
                });
        }


    }

    function replaceTextPatterns() {
        var elements = document.querySelectorAll('.replace-umlauts');

        elements.forEach(function (element) {
            element.innerHTML = element.innerHTML
                .replace(/Loeslichkeit/gi, 'Löslichkeit')
                .replace(/Destilliertin/gi, 'Destilliert in')
                .replace(/Phwert/gi, 'Ph-Wert')
                .replace(/Rueckgabe/gi, 'Rückgabe')
                .replace(/Casnummer/gi, 'CAS Nummer')
                .replace(/true/gi, 'ja')
                .replace(/false/gi, 'nein');
        });
    }
    replaceTextPatterns();
    window.replaceTextPatterns = replaceTextPatterns;

    var quickHelp = document.querySelector('.quickhelp');

    if (quickHelp) {
        var quickhelpOpener = document.getElementById('quickhelp-opener');
        var quickhelpWrapper = document.querySelector('.quickhelp-wrapper');
        var links = quickhelpWrapper.querySelectorAll('.quickhelp-inner a');
        var quickhelpClose = quickhelpWrapper.querySelector('.quickhelp-close');

        quickhelpOpener.addEventListener('click', function (event) {
            event.preventDefault();

            var tl = gsap.timeline();

            tl.to(quickhelpOpener, {
                x: 80,
                duration: 0.3,
                ease: "power1.out"
            })
                .to(quickhelpWrapper, {
                    left: 0,
                    duration: 0.3,
                    ease: "power1.out",
                    pointerEvents: "all"
                }, "-=0.15")
                .to(links, {
                    opacity: 1,
                    duration: 0.3,
                    stagger: 0.1,
                    ease: "power2.inOut"
                }, "-=0.15");
        });

        quickhelpClose.addEventListener('click', function (event) {
            event.preventDefault();
            var tl = gsap.timeline();

            tl.to(links, {
                opacity: 0,
                duration: 0.3
            })
                .to(quickhelpWrapper, {
                    left: '323px',
                    duration: 0.3,
                    ease: "power2.in",
                    pointerEvents: "none"
                }, "-=0.15")
                .to(quickhelpOpener, {
                    x: 0,
                    duration: 0.3,
                    ease: "power2.out"
                });
        });

        var lastScrollTop = 0;

        window.addEventListener('scroll', function () {
            var currentScroll = window.pageYOffset || document.documentElement.scrollTop;

            if (currentScroll > window.innerHeight * 0.1 && window.innerWidth <= 1023) {

                if (currentScroll > lastScrollTop) {
                    quickHelp.style.opacity = 0;
                    quickHelp.style.transition = "opacity 0.5s";
                } else {

                    if (currentScroll <= 0) {
                        quickHelp.style.opacity = 1;
                        quickHelp.style.transition = "opacity 0.5s";
                    }
                }
            } else {
                quickHelp.style.opacity = 1;
            }
            lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
        }, false);
    }


    document.querySelectorAll('ul.header__linklist a').forEach(function(link) {
        link.addEventListener('click', function(e) {

            const linkHost = new URL(link.href).host;
            const currentHost = window.location.host;
            if (linkHost !== currentHost) {

                e.preventDefault();
                window.open(link.href, '_blank');
            }
        });
    });

});
